import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'lib-app-sidebar',
  standalone: true,
  imports: [CommonModule],
  encapsulation: ViewEncapsulation.None,
  template: `
    <aside class="app-sidebar">
      <div class="app-sidebar__brand">
        <ng-content select="[libAppSidebarBrand]"></ng-content>
      </div>

      <nav class="app-sidebar__nav">
        <ng-content></ng-content>
      </nav>

      <div class="app-sidebar__footer">
        <ng-content select="[libAppSidebarFooter]"></ng-content>
      </div>

      <div class="app-sidebar__footer-spacer" aria-hidden="true"></div>
    </aside>
  `,
  styles: [`
    .app-sidebar {
      width: 100%;
      height: 100%;
      min-height: 100%;
      flex: 1 1 auto;
      background: transparent;
      color: var(--tenant-sidebar-text, #ffffff);
      display: flex;
      flex-direction: column;
      padding: 16px;
      box-sizing: border-box;
      overflow: visible;
    }

    .app-sidebar__brand {
      margin-bottom: 24px;
      display: flex;
      flex-direction: column;
      gap: 3px;
    }

    .app-sidebar__brand:empty {
      display: none;
      margin-bottom: 0;
    }

    .app-sidebar__brand-title {
      font-size: 18px;
      font-weight: 600;
      color: var(--tenant-sidebar-text, #ffffff);
    }

    .app-sidebar__brand-subtitle {
      font-size: 12px;
      color: color-mix(in srgb, var(--tenant-sidebar-text, #ffffff) 70%, transparent);
      text-transform: uppercase;
      letter-spacing: 0.08em;
    }

    .app-sidebar__nav {
      display: flex;
      flex-direction: column;
      gap: 8px;
      flex: 1 1 auto;
      min-height: 0;
    }

    .app-sidebar__footer {
      margin-top: auto;
      padding-top: 18px;
      padding-bottom: 8px;
      flex: 0 0 auto;
      border-top: 1px solid color-mix(in srgb, var(--tenant-sidebar-text, #ffffff) 16%, transparent);
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .app-sidebar__footer-spacer {
      flex: 0 0 auto;
      height: calc(60px + env(safe-area-inset-bottom, 0px));
    }

    .app-sidebar__link {
      color: color-mix(in srgb, var(--tenant-sidebar-text, #ffffff) 82%, transparent);
      text-decoration: none;
      padding: 10px 12px;
      border-radius: 8px;
      transition: background 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      border: 1px solid transparent;
    }

    .app-sidebar__link:hover {
      background: color-mix(in srgb, var(--tenant-sidebar-bg, var(--tenant-secondary, #111827)) 78%, white);
      color: var(--tenant-sidebar-text, #ffffff);
      border-color: color-mix(in srgb, var(--tenant-sidebar-text, #ffffff) 20%, transparent);
    }

    .app-sidebar__link--active {
      background: var(--tenant-primary, #2563eb);
      color: #ffffff;
      border-color: var(--tenant-primary, #2563eb);
    }

    .app-sidebar__link-label {
      min-width: 0;
    }

    .app-sidebar__pending-dot {
      flex: 0 0 auto;
      width: 9px;
      height: 9px;
      border-radius: 999px;
      background: var(--tenant-accent, #f59e0b);
      box-shadow: 0 0 0 4px color-mix(in srgb, var(--tenant-accent, #f59e0b) 24%, transparent);
      animation: app-sidebar-pending-blink 1000ms steps(1, end) infinite;
    }

    @keyframes app-sidebar-pending-blink {
      0%, 50% {
        opacity: 1;
      }
      51%, 100% {
        opacity: 0;
      }
    }
  `],
})
export class AppSidebarComponent {}
